import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HStack, Icon, Text } from '@chakra-ui/react';
import { faWarning } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
export default function ErrorNotice(param) {
    var children = param.children;
    if (children === null) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(HStack, {
        spacing: 2,
        color: "negative",
        alignItems: "center",
        children: [
            /*#__PURE__*/ _jsx(Icon, {
                as: FontAwesomeIcon,
                icon: faWarning
            }),
            /*#__PURE__*/ _jsx(Text, {
                children: children
            })
        ]
    });
}
